import React, { useState, useRef, useEffect, useCallback, Fragment } from "react";
import { connect } from "react-redux";
import clsx from "clsx";
import { fade, makeStyles, useTheme } from "@material-ui/core/styles";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import {
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ButtonToolbar,
} from "reactstrap";

import { bindActionCreators } from 'redux';
import searchActions from '../../../../redux/actions/searchActions';

import ExportView from "./ExportView";
import axios from "axios";
import ReactDOMServer from "react-dom/server";
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";

import {
  Tooltip,
  Drawer,
  CssBaseline,
  AppBar,
  Toolbar,
  Typography,
  Divider,
  Slide,
} from "@material-ui/core";
import FileExportIcon from "mdi-react/FileImportIcon";
import ExportSettingsForm from "./ExportSettingsForm";
import { Publisher } from "../../../../shared/pubsub/publisher.js";
import LinearLoading from "../../../../shared/components/LinearLoading";
import FileDocumentEditOutlineIcon from "mdi-react/FileDocumentEditOutlineIcon";
import { _getNeighborhoods } from "../../../../shared/helpers/apicalls";
import { _axiosCall } from "../../../../shared/helpers/apicalls";
import IconButton from "@material-ui/core/IconButton";
import ChevronLeftIcon from "mdi-react/ChevronLeftIcon";
import ChevronRightIcon from "mdi-react/ChevronRightIcon";
import ChevronDownIcon from "mdi-react/ChevronDownIcon";
import ChevronUpIcon from "mdi-react/ChevronUpIcon";
import LogoIcon from "mdi-react/StarBoxOutlineIcon";
import SummaryIcon from "mdi-react/FileDocumentEditOutlineIcon";
import DetailsIcon from "mdi-react/FormatListCheckboxIcon";
import SettingsIcon from "mdi-react/CogIcon";
import ChartIcon from "mdi-react/ChartAreasplineIcon";
import MapIcon from "mdi-react/MapMarkerIcon";
import ThemeIcon from "mdi-react/PaletteIcon";
import TimeIcon from "mdi-react/AvTimerIcon";
import EditIcon from "mdi-react/PencilIcon";
import PreviewIcon from "mdi-react/EyeOutlineIcon";
import RefreshIcon from "mdi-react/RefreshIcon";
import CopyIcon from "mdi-react/ContentCopyIcon";

import GeneralBuildingSearchBar from "../../../../shared/components/building_filters/GeneralBuildingSearchBar";
import RecentHistory from './RecentHistory';

import PropertyType from "../reportviews/reports/PropertyType";
import NewDev from "../reportviews/reports/NewDev";
import CondoReport from "../reportviews/reports/CondoReport";
import CoopReport from "../reportviews/reports/CoopReport";
import LuxuryReport from "../reportviews/reports/LuxuryReport";
import TownhouseReport from "../reportviews/reports/TownhouseReport";
import RentalReport from "../reportviews/reports/RentalReport";

import SocialMarketOverview from "../reportviews/social/SocialMarketOverview";
import SocialNewDev from "../reportviews/social/SocialNewDev";
import SocialLuxury from "../reportviews/social/SocialLuxury";
import SocialCondo from "../reportviews/social/SocialCondo";
import SocialCoop from "../reportviews/social/SocialCoop";
import SocialTownhouse from "../reportviews/social/SocialTownhouse";

import NewsletterMarketTrends from "../reportviews/newsletters/NewsletterMarketTrends";
import NewsletterNewDev from "../reportviews/newsletters/NewsletterNewDev";
import NewsletterLuxury from "../reportviews/newsletters/NewsletterLuxury";
import NewsletterCondo from "../reportviews/newsletters/NewsletterCondo";
import NewsletterCoop from "../reportviews/newsletters/NewsletterCoop";
import NewsletterTownhouse from "../reportviews/newsletters/NewsletterTownhouse";
import NewsletterCustom from "../reportviews/newsletters/NewsletterCustom";
import PostCardMarketTrends from "../reportviews/postcards/MarketOverview";
import PostCardNewDev from "../reportviews/postcards/NewDev";
import PostCardLuxury from "../reportviews/postcards/LuxuryReport";
import PostCardCondo from "../reportviews/postcards/CondoReport";
import PostCardCoop from "../reportviews/postcards/CoopReport";
import PostCardTownHouse from "../reportviews/postcards/TownhouseReport";
import BuildingMarketOverView from "../reportviews/buildingviewreport/PropertyType"


import CompPropertySelector from './CompPropertySelector';
import RentalCompPropertySelector from './RentalCompPropertySelector';
import BuildingSearchSelector from './BuildingSearchSelector';
import PropertySelector from './PropertySelector';
import ListingDescSelector from './ListingDescSelector';


import BuildingMarketProofView from "../reportviews/buildingviewreport1/PropertyType";
import  BuildingMarketProofViewComp from "../reportviews/propertycompreport/PropertyType"
import BuildingMarketProofViewCompRental from "../reportviews/rentalcompreport/PropertyType"
import  NewsLetterComp from "../reportviews/newslettercompreport/PropertyType";
import  ListingDesc from "../reportviews/listingdesc/PropertyType";


import VideoMarketReport from "../reportviews/video/PropertyType";
import VideoLuxuryReport from "../reportviews/video/LuxuryReport";


import HeyGenExportButton from "./HeyGenExportButton";
import SnackBar from '../../../../shared/components/SimpleSnackBar';
import NestedModal from "./NestedModal"; // Adjust path if needed
import CompSourceSelector from './CompSourceSelector'; // Adjust the path based on where you put it
import DetailModal from './DetailModal'

import Fab from "@material-ui/core/Fab";
import CloseIcon from "mdi-react/CloseIcon";
import ExitToAppIcon from "mdi-react/ExitToAppIcon";
import TrashCanIcon from "mdi-react/TrashCanOutlineIcon";

import { _isEqual } from "../../../../shared/helpers/utils";
import CustomDateComp from "../CustomDate/CustomDateComp.jsx";
import { findStyles } from "./utils.js";
import ZoomSlider from "./Slider";
import { _hasPermission	} from "../../../../shared/helpers/access";
import { themeOptions } from './utils';
import { saveCompDraft, deleteCompDraft, RENTAL_COMP_DRAFT_KEY } from './compDraftStorage';

function _getReportModalThemeClass() {
  if (typeof document === 'undefined') return '';
  if (document.querySelector('.role-bhs-agent')) return 'role-bhs-agent';
  if (document.querySelector('.role-elliman-agent')) return 'role-elliman-agent';
  return '';
}



const apiUrl = process.env.API_ROOT + "/";
const exportAPIURL = process.env.MP_EXPORT_SERVER;

const drawerWidth = 800; // Set the width of the drawer

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: "#780F9E !important",
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    color: "#FFF !important",
    alignItems: "center",
    padding: "2px 15px",
  },
  appToolBar: {
    justifyContent: "space-between",
    width: "100% !important",
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: drawerWidth,
  },
  toolBar: {
    paddingLeft: 0,
    paddingRight: 0,
    width: 1200,
    justifyContent: "center",
  },
  toolBarButtonGroup: {
    justifyContent: "end",
  },
  button: {
    color: "#FFF",
    borderColor: "#FFF",
    backgroundColor: "#9600BF",
    margin: "0px 5px",
    minWidth: 100,
    "&:hover": {
      borderColor: "#FFF", // A darker shade for the hover state
      backgroundColor: "#B070CC", // Slight background on hover
    },
    "&.activeButton": {
      borderColor: "#FFF", // A darker shade for the hover state
      backgroundColor: "#5C1F7A", // Slight background on hover
    },
  },
  fab: {
    fontWeight: 600,
    background: "#780F9E",
    width: 200,
    "&.Mui-disabled": {
      color: "#F5F7FA",
      background: "#DBE0E8",
    },
    "&:hover": {
      background: "#9600BF",
    },
  },
  fabClose: {
    fontWeight: 600,
    borderColor: "#780F9E",
    color: "#780F9E",
    background: "#FFF",
    marginLeft: "5px",
    "&.Mui-disabled": {
      color: "#F5F7FA",
      background: "#DBE0E8",
    },
    "&:hover": {
      background: "#F5F7FA",
    },
  },
  title: {
    textAlign: "left",
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    zIndex: 100,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "space-between",
    marginBottom: 0,
    minHeight: 0,
  },

  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }), // Use dynamic margin based on slider height
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: 0,
  },

  
}));




const searchBarStyles = makeStyles((theme) => ({
  searchBarContainer: {
    width: "100%",
    position: "fixed",
    left: 0,
    top: 60,
    padding: "30px 20px",
    zIndex: 99,
    background: "#78199E",
  },
  appBar: {
    backgroundColor: "#780F9E !important",
    transform: "none !important",
    color: "#FFF !important",
    boxShadow: "none",
    "&.MuiToolbar-gutters": {
      paddingRight: "0px !important",
    },
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: "-24px !important",
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: 0, //theme.spacing(3),
      width: "100%",
      maxWidth: "none",
    },
    "& .c_input-tag": {
      background: "#780F9E",
      color: "#FFF",
    },
    "& .poly_map_launcher": {
      background: "#5C1F7A !important",
    },
    "&.MuiToolbar-gutters": {
      paddingRight: 0,
    },
    "& .mdi-icon": {
      fill: "#FFF",
    },
  },
  searchIcon: {
    width: theme.spacing(7),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "#FFF !important",
    width: "100%",
    ".c_nav-input.MuiInputBase-input":{
      color:"#fff !important"
    }
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 7) + " !important",
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "80%",
    },
    color: "#222 !important",
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  searchButton: {
    color: "#FFF",
    borderColor: "#FFF",
    backgroundColor: "#5C1F7A",
    margin: "0px 5px",
    "&:hover": {
      borderColor: "#FFF", // A darker shade for the hover state
      backgroundColor: "#B070CC", // Slight background on hover
    },
    minWidth: 120,
    height: 46,
    marginLeft: -40,
    boxShadow:
      "rgba(0, 0, 0, 0.1) 0px 0px 1px -3px, rgba(0, 0, 0, 0.1) 0px 1px 2px 0px, rgba(0, 0, 0, 0.1) 0px 1px 4px 0px",
    "&.Mui-disabled": {
      boxShadow: "none",
      color: "#9600BF",
    },
  },
}));

const searchBarBuildingStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor:'#F5F7FA !important',
    transform:'none !important',
    color:'#FFF !important',
    boxShadow:"none",
    padding: 'none !important',
    "& .MuiToolbar-gutters": {
      paddingRight: "0px !important",
      paddingLeft: "0px !important",
    },
    },
   
    grow: {
      flexGrow: 1,
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    title: {
      display: 'none',
      [theme.breakpoints.up('sm')]: {
        display: 'block',
      },
    },
    search: {
      position: "relative",
      borderRadius: theme.shape.borderRadius,
      backgroundColor: " #FFF !important",
      border:"2px solid #333",
      marginRight: "0px !important",
      marginLeft: "0px !important",
      width: "100%",
      [theme.breakpoints.up("sm")]: {
        marginLeft: 0, //theme.spacing(3),
        width: "100%",
        maxWidth: "none",
      },
      "& .c_search-result-container":{
        boxShadow:"none",
        top:"50px"
      },
      "& .c_input-tag": {
        background: "#A3ADC2",
        color: "#FFF",
        "& .mdi-icon": {
          fill: "#FFF",
        },
      },
      "& .poly_map_launcher": {
        background: "#5C1F7A !important",
      },
      "&.MuiToolbar-gutters": {
        paddingRight: 0,
      },
      "& .mdi-icon": {
        fill: "#A3ADC2",
      },
      "& .c_search-nav": {
        color: "#A3ADC2",
        "& .c_nav-input.MuiInputBase-input":{
          color: "#A3ADC2",
        
        },
      
      },

    },
    searchIcon: {
      width: theme.spacing(7),
      height: "100%",
      position: "absolute",
      pointerEvents: "none",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    inputInput: {
      padding: theme.spacing(1, 1, 1, 7) + " !important",
      transition: theme.transitions.create("width"),
      width: "100%",
      [theme.breakpoints.up("md")]: {
        width: "80%",
      },
      color: "#222 !important",
    },

    inputRoot: {
      color: 'inherit',
      width: '100%',
    },

    sectionDesktop: {
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: 'flex',
      },
    },
    sectionMobile: {
      display: 'flex',
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
    searchButton: {
      color: "#FFF",
      borderColor: "#FFF",
      backgroundColor: "#5C1F7A",
      margin: "0px 5px",
      "&:hover": {
        borderColor: "#FFF", // A darker shade for the hover state
        backgroundColor: "#B070CC", // Slight background on hover
      },
      minWidth: 120,
      height: 46,
      marginLeft: -40,
      boxShadow:
        "rgba(0, 0, 0, 0.1) 0px 0px 1px -3px, rgba(0, 0, 0, 0.1) 0px 1px 2px 0px, rgba(0, 0, 0, 0.1) 0px 1px 4px 0px",
      "&.Mui-disabled": {
        boxShadow: "none",
        color: "#9600BF",
      },
    },
  }));
  export const searchBarStylesPurple = makeStyles(theme => ({
    appBar: {
    backgroundColor:'#780F9E !important',
    transform:'none !important',
    color:'#FFF !important'
    },
    ".MuiToolbar-regular":{
      paddingLeft:0,
      paddingRight:0
    },
    grow: {
      flexGrow: 1,
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    title: {
      display: 'none',
      [theme.breakpoints.up('sm')]: {
        display: 'block',
      },
    },
    search: {
      position: 'relative',
      borderRadius: theme.shape.borderRadius,
      backgroundColor: fade(theme.palette.common.white, 0.15),
      '&:hover': {
        backgroundColor: fade(theme.palette.common.white, 0.25),
      },
      marginRight: theme.spacing(2),
      marginLeft: 0,
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        marginLeft: 0, //theme.spacing(3),
        width: '90%',
        maxWidth:800
      },
    },
    searchIcon: {
      width: theme.spacing(7),
      height: '100%',
      position: 'absolute',
      pointerEvents: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    inputRoot: {
      color: 'inherit',
      width: '100%',
    },
    inputInput: {
      padding: theme.spacing(1, 1, 1, 7) + ' !important',
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('md')]: {
        width: '80%',
      },
      color:'#FFF !important'
    },
    sectionDesktop: {
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: 'flex',
      },
    },
    sectionMobile: {
      display: 'flex',
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
}));
function formatDate() {
  const date = new Date();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear();

  return `${month}/${day}/${year}`;
}

const dateFormatted = formatDate();

const sanitizeResults = (result, paragraphs) => {
  let sanitized = result.replace(/undefined/g, "");

  // Remove leading newlines
  sanitized = sanitized.replace(/^\n+/, "");

  // Protect code blocks and inline code from being altered
  sanitized = sanitized.replace(
    /```([^```]*)```/gim,
    "<pre><code>$1</code></pre>"
  );
  sanitized = sanitized.replace(/`([^`]*)`/gim, "<code>$1</code>");

  // Headers
  sanitized = sanitized.replace(/^### (.*$)/gim, "<b>$1</b>");
  sanitized = sanitized.replace(/^## (.*$)/gim, "<b>$1</b>");
  sanitized = sanitized.replace(/^# (.*$)/gim, "<b>$1</b>");

  // Bold and italic
  sanitized = sanitized.replace(/\*\*\*(.+?)\*\*\*/gim, "<b><i>$1</i></b>");

  // Bold
  sanitized = sanitized.replace(/\*\*(.+?)\*\*/gim, "<b>$1</b>");

  // Italic
  sanitized = sanitized.replace(/\*(.+?)\*/gim, "<i>$1</i>");

  // Underline
  sanitized = sanitized.replace(/___(.+?)___/gim, "<u>$1</u>");

  // Links
  sanitized = sanitized.replace(/\[(.+?)\]\((.+?)\)/gim, '<a href="$2">$1</a>');

  // Blockquotes
  sanitized = sanitized.replace(/^\> (.*$)/gim, "<blockquote>$1</blockquote>");

  // Paragraph handling
  if (paragraphs) {
    sanitized = sanitized.replace(/(?:\n|\r|\n\n)+/g, "</p><p>");
    sanitized = `<p>${sanitized}</p>`;
  } else {
    sanitized = sanitized.replace(/(?:\n|\r|\n\n)+/g, "");
  }

  return sanitized;
};

const WritingInProgress = () => {
  const classes = useStyles();

  const phrases = [
    "Interpreting Trends",
    "Analyzing Data",
    "Compiling Insights",
    "Evaluating Metrics",
  ];
  const [currentPhrase, setCurrentPhrase] = useState(phrases[0]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentPhrase((prevPhrase) => {
        const currentIndex = phrases.indexOf(prevPhrase);
        const nextIndex = (currentIndex + 1) % phrases.length;
        return phrases[nextIndex];
      });
    }, 1000); // Change phrase every 2 seconds

    return () => clearInterval(intervalId); // Cleanup interval on unmount
  }, [phrases]);

  return (
    <Typography
      variant="h5"
      noWrap
      className={`writing-in-progress ${classes.drawerHeaderTitle}`}
      style={{ textAlign: "center" }}
    >
      <FileDocumentEditOutlineIcon
        size={32}
        color="#780F9E"
        style={{ marginTop: -5 }}
      />{" "}
      {currentPhrase}...
    </Typography>
  );
};
function defaultDate(building) {
  const now = moment();
  const startDate = building ? now.clone().subtract(1, "quarters").startOf("quarter") : now.clone().subtract(1, "month").startOf("month");
  const endDate = building ? now.clone().subtract(1, "quarters").endOf("quarter") : now.clone().subtract(1, "month").endOf("month");
  // const endDate = now.clone().startOf("month").utc();
  return {
    startDate,
    endDate,
  };
}
console.log(defaultDate(), "myModalClose");
function defaultPreviousPeriod(building) {
  const startDate = defaultDate(building).startDate.clone().subtract(1, "years");
  const endDate = defaultDate(building).endDate.clone().subtract(1, "years");

  return {
    startDate,
    endDate,
  };
}

const BuildingSearchScreen = (props) => {
  const { updateBuildingReport } = props;
  
  return  (<div
        style={{
          maxWidth: 900,
          margin: "0 auto",
         
        
          width:"100%",
          marginTop:180,
        }}
        >
        <h3
        style={{
          fontWeight:800,
          textAlign:"center",
          textTransform:"uppercase"
        }}
        >Search for a Building to Generate a Report</h3>
         <div
        style={{
          maxWidth: 900,
          
          margin: "0 auto",
          display: "flex",
          gap: 0,
          alignItems:"center"
        }}
      >
       
        <GeneralBuildingSearchBar
          buildingFilter={
            '(ownership_type:"condo" OR ownership_type:"condo-retail" OR building_status:"sponsor" OR ownership_type:"coop" OR ownership_type:"rental")'
          }
          handleSearch={updateBuildingReport}
          buildingAttributes={[]}
          placeHolder={
            "Address or Building Name"
          }
          addBuilding={false}
          buildingTab={null}
          hideBoroHood={true}
          hideAddIcon={true}
          hideMapDraw={true}
           searchBarStyles={searchBarBuildingStyles}
           exitMessageData={{title:"Report Unavailable", message:"Building reports are currently available for condos and co-ops.  Click continue if you would like to learn more about this property on our public website."}}
        />
       
      </div>
      <hr/>
      
      
      <RecentHistory {...props} handleSearch={updateBuildingReport} />
    </div>)
}

const ExportModal = (props) => {
  const {
    html,
    user: userProp,
    parentFetchInProgress,
    getUnitList,
    setDetails,
    reportParams,
    renderListViewHTML,
    renderStatsHTML,
    searchTags,
    _renderChartHTML,
    isModalOpen,
    toggleModal,
    reportComponent,
    layoutStyle,
    isHeaderAvailable,
    isFooterAvailable,
    reportItem,
    submit,
    setSubmit,
    isBuilding,
    setIsBuilding,
    isMedia,
    setIsMedia,
    setLayoutStyle,
    clearTags,
    addTag
  } = props;
  
  console.log(props)
  
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [panel, setPanel] = useState(false);
  const [progress, setProgress] = useState("");
  const [orientation, setOrientation] = useState("portrait");
  const [preview, setPreview] = useState(false);
  const [fetchInProgress, setFetchInProgress] = useState(false);
  const [exportInProgress, setExportInProgress] = useState(false);
  const [boundingBoxCoord, setBoundingBoxCoord] = useState([]);
  const [isBoundsAvailable, setIsBoundsAvailable] = useState(false);
  const [aiRun, setAiRun] = useState(false); // State to track if handleAI has been run
  const [aiInProgress, setAIInProgress] = useState(false);
  const [isMapLoaded, setIsMapLoaded] = useState(false);
  const [unitListProgress, setUnitListProgress] = useState(false);
  const [formValuesCheckboxes, setFormValuesCheckboxes] = useState([]);
  const previewContainerRef = useRef(null);
  const [renderedChart, setRenderChart] = useState(null);
  const [reportLoaded, setReportLoaded] = useState(false);
  const [reportData, setReportData] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editedContent, setEditedContent] = useState(false);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [showDateComp, setShowtDateComp] = useState(false);
  const [showBrandingSlider, setShowBrandingSlider] = useState(false);
  const [showThemeSlider, setShowThemeSlider] = useState(false);
  const [reportSearchTags, setReportSearchTags] = useState(searchTags);
  const [selectedFont, setSelectedFont] = useState("Roboto");
  const [AiResponse, setAiResponse]=useState(null)
  const [compSettings, setCompSettings] = useState(false);
  const [fetchAi, setFetchAi]=useState(false)
  const [sliderHeight, setSliderHeight] = useState(0);
  const [zoom, setZoom] = useState(reportItem && reportItem.defaultZoom ? reportItem.deafultZoom : 100);
  const prevSearchTagsRef = useRef();
  const prevItemProps = useRef();
  const isFirstRender = useRef(true);

  const [areaChanged, setAreaChanged] = useState(false);
  
  const [isNestedModalOpen, setIsNestedModalOpen] = useState(false);
  const [nestedModalData, setNestedModalData] = useState(false);
  const [shareModal, setShareModal] = useState(false);
  const [shareKey, setShareKey] = useState(null);
  const [showExitConfirm, setShowExitConfirm] = useState(false);
  const [pageToDeleteIndex, setPageToDeleteIndex] = useState(null);
  
  const searchBarRef = useRef(null);
  const dateBarRef = useRef(null);
  const brandingSliderRef = useRef(null);
  const themeSliderRef = useRef(null);
  let brandingFromStorage = localStorage.getItem("branding");
  const contactFromStorage = localStorage.getItem("contact");
  const coverFromStorage = localStorage.getItem("cover");
  const themeFromStorage = localStorage.getItem("theme");
  const styleFromStorage = localStorage.getItem("style");
  const customColorFromStorage = localStorage.getItem("customColor");
  const customBGFromStorage = localStorage.getItem("customBackgroundColor");
  const customTextColorFromStorage = localStorage.getItem("customTextColor");
  console.log(Object.assign({}, reportItem));
  const isBuildingReport = reportItem && reportItem.isBuilding;
  // Reports whose data only supports certain geographies / intervals declare them; everything
  // else keeps the full set of controls.
  const reportSearchTypes = reportItem && reportItem.searchTypes ? reportItem.searchTypes : null;
  const reportDateIntervals = reportItem && reportItem.dateIntervals ? reportItem.dateIntervals : null;
  let themes = userProp && userProp.mcTheme && themeOptions[userProp.mcTheme] ? themeOptions[userProp.mcTheme] : themeOptions.default;

  const defaultValues = {
    reportTitle: "",
    summary: "",
    details: "no-details",
    branding:
    brandingFromStorage || (userProp && userProp.logo ? "mylogo" : ((reportItem && reportItem.marektproofBranding) || (userProp && userProp.corpLogo)) ? "marketproof" : "hide"),
    contact: contactFromStorage ? contactFromStorage : "show",
    cover: (userProp && !_hasPermission(userProp, 'mc-cover-page')) ? "hide" : coverFromStorage ? coverFromStorage : "hide",
    style: (userProp && !_hasPermission(userProp, 'custom-themes')) ? "style2" :  styleFromStorage || "default",
    customColor: customColorFromStorage || "#F53246",
    theme:  themeFromStorage && themes[themeFromStorage] ? themeFromStorage : "default",
    customBackgroundColor: customBGFromStorage || "#fdfdfd",
    textColor: customTextColorFromStorage || "#333",
    dateOptions: {
      startDate: defaultDate(isBuildingReport).startDate,
      endDate: defaultDate(isBuildingReport).endDate,
      previousStartDate: defaultPreviousPeriod(isBuildingReport).startDate,
      previousEndDate: defaultPreviousPeriod(isBuildingReport).endDate,
      gap: isBuildingReport ? "+3MONTH" : "+1MONTH",
      isCustomPreviousSelected: false,
      isPreviousSelectedClicked: false,
      isCurrentCustomSelected: false,
      anyChangeOccured: false,
    },
  };
  const [snackShow, setSnackShow]=useState(false);
  const [snackMessage, setSnackMessage]=useState(false);
  const [snackType, setSnackType]=useState('success');
 
console.log(defaultValues, userProp);
  const [color, setColor] = useState(
    customColorFromStorage || defaultValues.customColor
  );
  const [backgroundColor, setBackgroundColor] = useState(
    customBGFromStorage || defaultValues.customBackgroundColor
  );
  const [textColor, setTextColor] = useState(
    customTextColorFromStorage || defaultValues.textColor
  );

  const [formValues, setFormValues] = useState(defaultValues);
  const progressRef = useRef("");
  const iframeRef = useRef(null);
  const classes = useStyles();
  const searchClasses = searchBarStyles();
  const searchBuildingClasses=searchBarBuildingStyles()
  const theme = useTheme();
  const localStorageUser = localStorage.getItem("bl_user");
  const user = localStorageUser ? JSON.parse(localStorageUser) : userProp;
  
  const defaultLogo = user && user.corpLogo ? user.corpLogo : "https://marketproof-hosting.s3.amazonaws.com/logos/marketproof-logo-horizontal-transparent-background.png";

  // useEffect(()=>{
  //   localStorage.setItem("formValues", JSON.stringify(formValues));
  // },[formValues])
  // When comps changed with "Update Suggested Price", clear stale editedContent
  // synchronously so PropertyType renders fresh computed values immediately.
  const effectiveEditedContent = (reportData && reportData.updateSuggestedPrice) ? false : editedContent;

  const stateProps = {
    reportData,
    setReportData,
    fetchInProgress,
    setFetchInProgress,
    reportLoaded,
    setReportLoaded,
    formValues,
    color,
    setColor,
    backgroundColor,
    setBackgroundColor,
    textColor,
    setTextColor,
    editedContent: effectiveEditedContent
  };
  
  const jobIdRef = useRef(uuidv4()); // one jobId per component instance
  const restoringRef = useRef(false);
  const reportDataRef = useRef(reportData);
  reportDataRef.current = reportData; // Always keep ref in sync with state
  const downloadFileNameRef = useRef('');

  const setNestedModal = (data) => {
    // Use ref instead of closure to avoid stale value when ExportView's React.memo skips re-render
    const currentReportData = reportDataRef.current;
    // NestedModal requires reportData.derivedData — if background fetch isn't done yet, block.
    if (!currentReportData || !currentReportData.derivedData) {
      return;
    }

    // Map old compKey to fresh data for restored reports where comp IDs may differ
    if (data.compKey && data.compSection && data.compSectionIndex >= 0) {
      const { activeComps, soldComps } = currentReportData.derivedData;
      const sectionComps = data.compSection === "active" ? activeComps : soldComps;
      const found = sectionComps.some(function(c) { return String(c.id) === String(data.compKey); });

      if (!found) {
        // Sort by distance to match template display order
        var sorted = sectionComps.slice().sort(function(a, b) { return (a["geodist()"] || 0) - (b["geodist()"] || 0); });
        if (data.compSectionIndex < sorted.length) {
          data.compKey = sorted[data.compSectionIndex].id;
        }
      }
    }

    restoringRef.current = false; // Clear restore flag so subsequent renders use fresh ReportContent
    setNestedModalData(data);
    setIsNestedModalOpen(true);
  }

  console.log(reportComponent, "reportComponent");
  const setIframeContent = (height) => {
    const iframe = iframeRef.current;
    if (iframe) {
      const iframeDoc = iframe.contentDocument;
      iframe.style.height = `${height}px`;
    }
  };

  const styles = Array.from(
    document.querySelectorAll('style, link[rel="stylesheet"]')
  )
    .map((style) => {
      let clonedStyle = style.cloneNode(true);
      if (clonedStyle.tagName.toLowerCase() === "link") {
        const linkElement = clonedStyle;
        const href = linkElement.getAttribute("href");
        const absoluteUrl = new URL(href, document.baseURI).href;
        linkElement.setAttribute("href", absoluteUrl);
      }
      return clonedStyle.outerHTML;
    })
    .join("\n");
  console.log(isBuilding, "isBuilding");
  const ReportHeader = () => {
    return (
      <div className="header page-section header-section">
        <div className="export-header">
          <div>
            {formValues &&
            formValues.branding &&
            formValues.branding === "mylogo" &&
            user &&
            user.logo ? (
              <img className="header-logo" src={user.logo} />
            ) : formValues &&
              formValues.branding &&
              formValues.branding === "marketproof" ? (
              <img
                className="header-logo"
                src={defaultLogo}
              />
            ) : null}
          </div>
          <div>{ReportContact()}</div>
        </div>
      </div>
    );
  };

  const summarizeGeographies = (dataArray, shortVersion = false) => {
    // First, filter and prioritize boroughs
    const boroughs = dataArray
      .filter((item) => item.type === "borough")
      .map((item) => item.name.charAt(0).toUpperCase() + item.name.slice(1));

    // Then, gather the neighborhood names
    const neighborhoods = dataArray
      .filter((item) => item.type === "neighborhood")
      .map((item) => item.name.charAt(0).toUpperCase() + item.name.slice(1));

    // Finally, gather the building names
    const buildings = dataArray
      .filter((item) => item.type === "building")
      .map((item) => item.name.charAt(0).toUpperCase() + item.name.slice(1));

    // If there's a custom area (polygon), use its name or fallback to "Custom Area"
    const areas = dataArray
      .filter((item) => item.type === "area")
      .map(function(item) {
        if (item.id === "custom-area" && item.name) return item.name;
        return item.name || "Custom Area";
      });

    // Combine all lists with boroughs first, then neighborhoods, buildings, and areas
    const geographies = [...boroughs, ...neighborhoods, ...buildings, ...areas];

    // If there are more than 3 items, return the first two and "...and surrounding areas"
    if (geographies.length > 3) {
      return `${geographies[0]}, ${geographies[1]} and surrounding areas`;
    }

    // If shortVersion is true, return the first item and "and surrounding areas"
    if (shortVersion && geographies.length > 1) {
      return `${geographies[0]} and surrounding areas`;
    }

    // If there's more than one item, join them with commas and "and" before the last element
    if (geographies.length > 1) {
      return (
        geographies.slice(0, -1).join(", ") +
        " and " +
        geographies[geographies.length - 1]
      );
    }

    // If only one item, return it as is
    return geographies[0] || "";
  };

  //const ReportContent = <BlendedLayout {...props} {...stateProps} customDate={formValues} submit={submit} setSubmit={setSubmit}summarizeGeographies={summarizeGeographies} />

  const MyReportContent = () => {
    const componentsMap = {
      PropertyType: PropertyType,
      CondoReport: CondoReport,
      CoopReport: CoopReport,
      NewDev: NewDev,
      LuxuryReport: LuxuryReport,
      TownhouseReport: TownhouseReport,
      RentalReport: RentalReport,
      SocialMarketOverview: SocialMarketOverview,
      SocialNewDev: SocialNewDev,
      SocialLuxury: SocialLuxury,
      SocialCondo: SocialCondo,
      SocialCoop: SocialCoop,
      SocialTownhouse: SocialTownhouse,
      NewsletterMarketTrends: NewsletterMarketTrends,
      NewsletterNewDev: NewsletterNewDev,
      NewsletterLuxury: NewsletterLuxury,
      NewsletterCondo: NewsletterCondo,
      NewsletterCoop: NewsletterCoop,
      NewsletterTownhouse: NewsletterTownhouse,
      NewsletterCustom: NewsletterCustom,
      postCardNewDev: PostCardNewDev,
      postCardMarketTrend: PostCardMarketTrends,
      postCardLuxury: PostCardLuxury,
      postCardCondo: PostCardCondo,
      postCardCoop: PostCardCoop,
      postCardTownHouse: PostCardTownHouse,
       BuildingMarketOverView:BuildingMarketOverView,
      BuildingMarketProofView:BuildingMarketProofView,
      BuildingMarketProofViewComp:BuildingMarketProofViewComp,
      BuildingMarketProofViewCompRental:BuildingMarketProofViewCompRental,
      NewsLetterComp:NewsLetterComp,
      VideoMarketReport: VideoMarketReport,
      VideoLuxuryReport: VideoLuxuryReport,
      ListingDesc: ListingDesc
      
    };
  
    const Component = componentsMap[reportComponent];
  console.log(Component, "component")
    if (!Component) return null; // Return null if the component is not defined
  
    const commonProps = {
      ...props,
      ...stateProps,
      customDate: formValues,
      submit,
      setSubmit,
      summarizeGeographies,
      color,
      logo: user.logo,
      compSettings,
      setAiResponse,
      AiResponse,
      fetchAi,
      setFetchAi,
      setAIInProgress,
      defaultLogo
    };
  
   
  console.log(fetchAi, "fetchAi")
    return <Component {...commonProps} />;
  };
  const ReportContent = MyReportContent()
  const ReportTitle = () => {
    if (!formValues || !formValues.reportTitle) return null;
    return (
      <div className="page-section">
        <div className="report-title">
          <h2>{formValues.reportTitle}</h2>
        </div>
      </div>
    );
  };

  const ReportSummary = () => {
    if (!formValues || !formValues.summary) return null;
    return (
      <div className="page-section">
        <div className="report-summary-container">
          <div className="report-summary">
            <div
              className="report-content"
              dangerouslySetInnerHTML={{ __html: formValues.summary }}
            />
          </div>
        </div>
      </div>
    );
  };

  const ReportFooter = () => {
    return null;
    return (
      <div className="page-section  footer-section">
        <div className="report-footer">
          Data by{" "}
          <a
            className="footer__logo"
            href={"https://marketproof.com/"}
            target="_blank"
          >
            <img
              src="https://marketproof-hosting.s3.amazonaws.com/logos/marketproof-logo-horizontal-transparent-background.png"
              style={{ width: 100 }}
            />
          </a>
          {" | "}
          {dateFormatted}
        </div>
      </div>
    );
  };

  const ReportLoading = () => {
    return (
      <div
        className="report-loading"
        style={
          layoutStyle
            ? {
                position: "relative",
                background: "#F5F7FA",
                paddingTop: "35%",
                width: `${layoutStyle.width}px`,
                height: "100vh",
                marginTop: "1.8rem",
              }
            : {
                height: "100vh",
                borderBottom: "20px solid #f5f7fa",
                position: "relative",
                paddingBottom: "60px",
                background: "#F5F7FA",
                paddingTop: "35%",
                paddingLeft: "20%",
                paddingRight: "20%",
                marginTop: "1.8rem",
              }
        }
      >
        <div className="logo" />
        <div style={layoutStyle && { width: "70%", margin: "auto" }}>
          <LinearLoading />
          <h2
            style={{
              padding: 20,
              fontSize: 24,
              fontWeight: 600,
              textTransform: "uppercase",
            }}
          >
            
            <WritingInProgress />
          </h2>
        </div>
      </div>
    );
  };
console.log(reportLoaded, "reportLoaded")
  const ListHTML = () => {
    if (!formValues.listHTML) return <></>;
    if (formValues.details && formValues.details == "no-details") return <></>;
    return <>{formValues.listHTML}</>;
  };

  const ReportContact = () => {
    if (formValues && formValues.contact && formValues.contact === "show") {
      return (
        <div className="page-section">
          <div className="report-contact">
            {user.avatar && !user.avatar.endsWith('/account.png') && <div
              className="avatar-img"
              style={{ backgroundImage: `url(${user.avatar})` }}
              alt="avatar"
            />}

            <div>
              <p className="contact-name">
                {user.firstName} {user.lastName}
                <br />
              </p>
              <div className="contact-title">
                {user.title && <span>{user.title}</span>}
                {user.company && (
                  <span>
                    {user.title ? " | " : null}
                    {user.company}
                  </span>
                )}

                {user.agentLicenseNumber && (
                  <span>
                    {" "}
                    {" | "}License #: {user.agentLicenseNumber}
                  </span>
                )}
              </div>
              <div className="contact-info">
              <div className="phone">
                {user.primaryPhone && (
                  
                    <>O: {user.primaryPhone}</>
                  
                )}
                {user.mobilePhone && (
                  <>
                   <>{user.primaryPhone && " | "}</>
                    <>M: {user.mobilePhone}</>
                   </>
                  
                )}
                </div>
              
                {user.email && <div className="email">{user.email}</div>}
                
              </div>
              </div>
            </div>
          </div>
      );
    }
    return null;
  };

  const headerContent = `
    <style>
    body {
      font-family: Arial, sans-serif;
    }
    .key-stat{
      font-size:30px !important;
    }
    .page-section{
      width:100%;
    }
    .export-header{
      padding: 20px 20px;
      display: flex;
      align-items: center;
      margin-bottom: 50px;
      border-bottom: 1px solid #333;
      justify-content:space-between;
    }
    .report-contact{
      display:flex;
    }
    .report-contact .avatar-img {
      margin-right:10px;
    }
    .report-contact .contact-name{
      font-size:22px;
      font-weight:700;
      line-height:27px;
    }
    .report-contact .contact-title, .report-contact .contact-info{
      font-size:18px;
      font-weight:300;
      line-height:21px;
    }
    .report-contact .avatar-img{
      width:70px;
      height:70px;
      background-size:cover;
      border-radius:50%;
    }
    .report-title{
      margin:20px;
    }
    .report-summary-container{
      height:950px;
    }
    .report-summary{
      margin:20px;
      padding:20px;
      background:#F5F7FA;
      margin-bottom:30px;
    }
    .report-summary .report-content{
      font-size:20px;
      column-count:2;
    }
    .report-title h2{
      font-weight: 700;
      text-transform: uppercase;
      padding-bottom: 15px;
      border-bottom: 1px solid #AAA;
      margin-bottom: 30px;
    }
    .editable[contenteditable=true] {
      outline: 1px dashed #FF206E;
      position:relative;
    }
    .editable[contenteditable=true]:hover::before {
      content: "Click to Edit";
      text-transform:uppercase;
      background-color: #FF206E;
      color: #FFF;
      font-weight: bold;
      position: absolute;
      left: 0;
      font-size: 12px;
      line-height: 12px;
      padding: 8px 20px;
      text-align: center;
      height: 30px;
      top: 0;
      display: block;
      font-family: 'Montserrat';
      margin: 0;
      
    }
    .editable[contenteditable=true]:active::before, .editable[contenteditable=true]:focus::before{
      width:0;
      height:0;
      display:none;
    }
    @media print {
      body {
        transform: scale(1); /* Zoom to 80% */
      }
      .editable[contenteditable=true] {
        outline: none;
      }
    }
    </style>
    ${styles}
  `;

  const scripts = `
    <script src="https://cdnjs.cloudflare.com/ajax/libs/react/17.0.2/umd/react.production.min.js"></script>
    <script src="https://cdnjs.cloudflare.com/ajax/libs/react-dom/17.0.2/umd/react-dom.production.min.js"></script>
    <script src="https://cdnjs.cloudflare.com/ajax/libs/recharts/2.0.10/Recharts.min.js"></script>
  `;
  useEffect(() => {
    console.log("ExportModal reportLoaded", reportLoaded);
  }, [reportLoaded]);
  
  useEffect(() => {
    const isBuildingReport = reportItem && reportItem.isBuilding;
  // Reports whose data only supports certain geographies / intervals declare them; everything
  // else keeps the full set of controls.
  const reportSearchTypes = reportItem && reportItem.searchTypes ? reportItem.searchTypes : null;
  const reportDateIntervals = reportItem && reportItem.dateIntervals ? reportItem.dateIntervals : null;
    const isWeeklyTemplate = reportItem && reportItem.reportComponent === "NewsletterCustom";

    if (isWeeklyTemplate) {
      const lastWeekStart = moment().subtract(1, "week").startOf("isoWeek");
      const lastWeekEnd = moment().subtract(1, "week").endOf("isoWeek");
      const prevWeekStart = moment().subtract(2, "weeks").startOf("isoWeek");
      const prevWeekEnd = moment().subtract(2, "weeks").endOf("isoWeek");
      setFormValues(Object.assign({}, formValues, { dateOptions: {
          startDate: lastWeekStart,
          endDate: lastWeekEnd,
          previousStartDate: prevWeekStart,
          previousEndDate: prevWeekEnd,
          gap: "+7DAY",
        }}));
      // Auto-set Manhattan South of 96th Street area tag
      setTimeout(function() {
        clearTags();
        addTag({
          id: "custom-area",
          type: "area",
          name: "Manhattan South of 96th Street",
          data: { type: "polygon", coordinates: [[[-73.97778826567416,40.79717263461296],[-73.94276191908436,40.78255596254556],[-73.9408313330513,40.77430656329429],[-73.96854903251845,40.741612165071814],[-73.96874059644324,40.72220180307545],[-73.97525376990846,40.70942449288347],[-73.9790850484172,40.70739151289348],[-73.99804987703672,40.7050680311948],[-74.01241717144515,40.695773293791916],[-74.0264013380032,40.70782715668773],[-74.01682314173051,40.7391860200006],[-74.0069612479541,40.76647334481791],[-73.9960421042035,40.78069026781637],[-73.97778826567416,40.79717263461296]]] },
        });
      }, 0);
    } else {
      setFormValues(Object.assign({}, formValues, { dateOptions: {
          startDate: defaultDate(isBuildingReport).startDate,
          endDate: defaultDate(isBuildingReport).endDate,
          previousStartDate: defaultPreviousPeriod(isBuildingReport).startDate,
          previousEndDate: defaultPreviousPeriod(isBuildingReport).endDate,
          gap: isBuildingReport ? "+3MONTH" : "+1MONTH",
        }}));
    }
      if(reportItem && reportItem.defaultZoom){
        setZoom(reportItem.defaultZoom)
      }

  }, [reportItem]);
  
  useEffect(function () {
    var url = exportAPIURL + '/events?jobId=' + encodeURIComponent(jobIdRef.current);
    var es = new EventSource(url); // add { withCredentials: true } if you rely on cookies
  
    function onProgress(ev) {
      try {
        var data = JSON.parse(ev.data);
        if (!data || data.jobId !== jobIdRef.current) return;

        if (progressRef.current !== data.status) {
          progressRef.current = data.status;
          setProgress(String(data.status));
        }

        // When the server sends the final URL via SSE, trigger download
        if (data.url) {
          var sseUrl = data.url;
          fetch(sseUrl)
            .then(function (r) { return r.blob(); })
            .then(function (blob) {
              var downloadUrl = window.URL.createObjectURL(blob);
              var a = document.createElement('a');
              a.href = downloadUrl;
              a.download = downloadFileNameRef.current || 'export.pdf';
              document.body.appendChild(a);
              a.click();
              a.remove();
              window.URL.revokeObjectURL(downloadUrl);
              setProgress('Download complete');
              setTimeout(function () { setProgress(null); }, 2000);
              setExportInProgress(false);
              var customData = {
                file: sseUrl,
                reportName: reportItem && reportItem.name ? reportItem.name : '',
                reportComponent: reportItem && reportItem.reportComponent ? reportItem.reportComponent : ''
              };
              Publisher.publish('track-mp.aiMarketingCenterExport', {
                user: user,
                customData: customData,
              });
            })
            .catch(function (err) {
              console.error('SSE download error:', err);
              setProgress('Error downloading file');
              setExportInProgress(false);
            });
        }

        // Handle errors from SSE
        if (data.error) {
          setProgress('Error generating PDF');
          setExportInProgress(false);
        }
      } catch (e) {
        // ignore bad JSON
      }
    }

    es.addEventListener('progress', onProgress);

    return function () { es.close(); };
  }, []);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const openDrawer = (panel) => {
    setPanel(panel);
    setIsDrawerOpen(!isDrawerOpen);
    setShowtDateComp(false);
  };

  const scrollToTop = () => {
    if (previewContainerRef.current) {
      //previewContainerRef.current.scrollTo({ top: 0, behavior: "smooth" });
      if (previewContainerRef.current.scrollTop > 0) {
        // Scroll to top
        previewContainerRef.current.scrollTop = 0;
      }
    }
  };

  const handleSaveChanges = useCallback((updatedContent) => {
    setEditedContent(updatedContent); // Save edited content
  }, []);

  const handleRestoreCompDraft = (draft) => {
    // Validate draft has valid building data before restoring
    if (!draft.compSettings || !draft.compSettings.selectedBuilding) {
      console.warn("Invalid comp draft: missing selectedBuilding");
      deleteCompDraft();
      return;
    }

    // Re-create propertyDetails.property that was stripped during save (sanitizeCompSettings
    // removes it to avoid circular references in JSON). getDerived() needs this field.
    // Original: Object.assign({}, selectedBuilding, {address_2_normalized: selectedUnit})
    if (draft.compSettings.propertyDetails && !draft.compSettings.propertyDetails.property) {
      draft.compSettings.propertyDetails.property = Object.assign(
        {},
        draft.compSettings.selectedBuilding,
        { address_2_normalized: draft.compSettings.selectedUnit || "" }
      );
    }

    // Restore settings BEFORE triggering report flow
    if (draft.compSettings) setCompSettings(draft.compSettings);
    if (draft.formValuesPartial) {
      setFormValues(prev => ({ ...prev, ...draft.formValuesPartial }));
    }

    // Flag for immediate display — ExportView gate now also passes when this is true,
    // so we show saved editedContent instantly without waiting for reportData.
    restoringRef.current = true;

    if (draft.reportData) {
      // We have saved reportData — use it directly, no fresh API fetch needed.
      // Reconstruct the circular self-reference stripped during save.
      if (draft.reportData.derivedData && draft.reportData.derivedData.subjectProperty) {
        draft.reportData.derivedData.subjectProperty.property =
          draft.reportData.derivedData.subjectProperty;
      }
      // Reconstruct compSettings.propertyDetails.property inside reportData
      if (draft.reportData.compSettings && draft.reportData.compSettings.propertyDetails
          && !draft.reportData.compSettings.propertyDetails.property) {
        draft.reportData.compSettings.propertyDetails.property = Object.assign(
          {},
          draft.compSettings.selectedBuilding,
          { address_2_normalized: draft.compSettings.selectedUnit || "" }
        );
      }
      setReportData(draft.reportData);
      setPreview(prev => !prev);
      scrollToTop();
      setIsBuilding(false);
      setIsMedia(false);
    } else {
      // Fallback for drafts saved before reportData was persisted
      updateBuildingReport();
    }

    // Override editedContent and AiResponse AFTER updateBuildingReport clears them.
    // React 17 batches setState in event handlers — last call wins.
    if (draft.editedContent) setEditedContent(draft.editedContent);
    if (draft.AiResponse) setAiResponse(draft.AiResponse);

    // Defer Redux tag dispatches to avoid breaking React's state batching.
    setTimeout(() => {
      if (draft.searchTags) {
        clearTags();
        draft.searchTags.forEach(tag => addTag(tag));
      }
    }, 0);
  };

  const isCompReportType = ["BuildingMarketProofViewComp", "BuildingMarketProofViewCompRental"].indexOf(reportComponent) >= 0;
  const saveCompDraftForCurrent = (data) => saveCompDraft(data, reportComponent === "BuildingMarketProofViewCompRental" ? RENTAL_COMP_DRAFT_KEY : undefined);

  const handleModalToggle = () => {
    // Save comp report draft when modal is closed via backdrop/escape
    if (isModalOpen && isCompReportType && compSettings && compSettings.selectedBuilding) {
      saveCompDraftForCurrent({
        editedContent,
        AiResponse,
        compSettings,
        searchTags,
        reportData,
        formValuesPartial: {
          reportTitle: formValues.reportTitle,
          summary: formValues.summary,
          details: formValues.details,
        },
      });
    }
    toggleModal();
  };

  const performExitReport = () => {
    const isCompReport = isCompReportType && compSettings && compSettings.selectedBuilding;
    if (isCompReport) {
      saveCompDraftForCurrent({
        editedContent,
        AiResponse,
        compSettings,
        searchTags,
        reportData,
        formValuesPartial: {
          reportTitle: formValues.reportTitle,
          summary: formValues.summary,
          details: formValues.details,
        },
      });
    }
    toggleModal();
    setFormValues({
      ...formValues,
      dateOptions: {
        startDate: defaultDate(isBuildingReport).startDate,
        endDate: defaultDate(isBuildingReport).endDate,
        previousStartDate: defaultPreviousPeriod(isBuildingReport).startDate,
        previousEndDate: defaultPreviousPeriod(isBuildingReport).endDate,
        gap: isBuildingReport ? "+3MONTH" : "+1MONTH",
        isCustomPreviousSelected: false,
        isPreviousSelectedClicked: false,
        anyChangeOccured: false,
      },
    });
    setIsBuilding && setIsBuilding(false);
    setIsMedia && setIsMedia(false);
    setReportData(null);
    setAiResponse(null);
    setFetchInProgress(false);
    setFetchAi(false);
  };

  const handleToggleSearchBar = () => {
    setShowtDateComp(false);
    setShowThemeSlider(false);
    setShowBrandingSlider(false);
    setShowSearchBar(!showSearchBar);
  };
  const handleToggleDateBar = () => {
    setShowSearchBar(false);
    setShowThemeSlider(false);
    setShowBrandingSlider(false);
    setShowtDateComp(!showDateComp);
  };
  const handleToggleBrandingSlider = () => {
    setShowThemeSlider(false);
    setShowSearchBar(false);
    setShowtDateComp(false);
    setShowBrandingSlider(!showBrandingSlider);
  };

  const handleToggleThemeSlider = () => {
    setShowBrandingSlider(false);
    setShowSearchBar(false);
    setShowtDateComp(false);
    setShowThemeSlider(!showThemeSlider);
  };

  const closeAllSliders = () => {
    setShowBrandingSlider(false);
    setShowSearchBar(false);
    setShowtDateComp(false);
    setShowThemeSlider(false);
  };

  const isSliderOpen = () => {
    return (
      showSearchBar || showDateComp || showBrandingSlider || showThemeSlider
    );
  };

  const updateSliderHeight = () => {
    setTimeout(() => {
      let sliderHeight = 0;

      if (showSearchBar && searchBarRef.current) {
        sliderHeight = searchBarRef.current.offsetHeight;
      } else if (showDateComp && dateBarRef.current) {
        sliderHeight = dateBarRef.current.offsetHeight;
      } else if (showBrandingSlider && brandingSliderRef.current) {
        sliderHeight = brandingSliderRef.current.offsetHeight;
      } else if (showThemeSlider && themeSliderRef.current) {
        sliderHeight = themeSliderRef.current.offsetHeight;
      }

      setSliderHeight(sliderHeight);
    }, 100); // Delay calculation to wait for rendering
  };

  useEffect(() => {
    updateSliderHeight(); // Calculate the height on initial render and when toggling sliders
  }, [showSearchBar, showDateComp, showBrandingSlider, showThemeSlider]);

  const handleClickOutside = function (event) {
    var polyMapModal = document.querySelector(".poly_map__modal");
    var headerElement = document.querySelector("header"); // Assuming your header has a <header> tag. Adjust the selector if needed.
    var popOverElement = document.querySelector(".MuiPopover-root");
    var formControlElement = document.querySelector(".MuiFormControl-root");
    console.log("here");
    // Check if the click is outside the search bar, not within the .poly_map__modal, and not within the header
    if (
      searchBarRef.current &&
      !searchBarRef.current.contains(event.target) &&
      !(polyMapModal && polyMapModal.contains(event.target)) && // Prevent closing if clicked inside .poly_map__modal
      !(headerElement && headerElement.contains(event.target)) // Prevent closing if clicked inside the header
    ) {
      setShowSearchBar(false); // Close the slider if clicked outside
    }
    if (
      dateBarRef.current &&
      !dateBarRef.current.contains(event.target) &&
      !(popOverElement && popOverElement.contains(event.target)) &&
      !(headerElement && headerElement.contains(event.target)) // Prevent closing if clicked inside the header
    ) {
      setShowSearchBar(false); // Close the slider if clicked outside
      setShowtDateComp(false);
    }
    if (
      brandingSliderRef.current &&
      !brandingSliderRef.current.contains(event.target) &&
      !(headerElement && headerElement.contains(event.target))
    ) {
      setShowBrandingSlider(false);
    }

    if (
      !(formControlElement && formControlElement.contains(event.target)) &&
      themeSliderRef.current &&
      !themeSliderRef.current.contains(event.target) &&
      !(headerElement && headerElement.contains(event.target))
    ) {
      setShowThemeSlider(false);
    }
  };

  useEffect(() => {
    // Add event listener for clicks outside the slider components
    const addOrRemoveClickListener = () => {
      if (
        showSearchBar ||
        showDateComp ||
        showBrandingSlider ||
        showThemeSlider
      ) {
        document.addEventListener("mousedown", handleClickOutside);
      } else {
        document.removeEventListener("mousedown", handleClickOutside);
      }
    };

    addOrRemoveClickListener();

    // Attach click listener to the iframe content document when iframe is available
    const iframe = iframeRef.current;

    if (iframe && iframe.contentWindow && iframe.contentWindow.document) {
      const iframeDoc = iframe.contentWindow.document;
      console.log("has iframe");

      // Attach the mousedown event initially
      const attachMouseDown = () => {
        iframeDoc.addEventListener("mousedown", (event) => {
          const clickEvent = new MouseEvent("mousedown", { bubbles: true });
          if (!editedContent) {
            closeAllSliders();
          }
        });
      };

      // Attach the event initially
      attachMouseDown();

      // Set up a MutationObserver to watch for content changes
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === "childList" || mutation.type === "subtree") {
            // Reattach the event after content changes
            attachMouseDown();
          }
        });
      });

      // Observe changes in the iframe document
      observer.observe(iframeDoc, { childList: true, subtree: true });

      // Disconnect the observer when no longer needed (e.g., on unmount)
      return () => observer.disconnect();
    }

    // Cleanup event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);

      if (iframe && iframe.contentWindow && iframe.contentWindow.document) {
        const iframeDoc = iframe.contentWindow.document;
        iframeDoc.removeEventListener("mousedown", handleClickOutside);
      }
    };
  }, [
    showSearchBar,
    showDateComp,
    showBrandingSlider,
    showThemeSlider,
    iframeRef,
  ]);


  const updateReport = () => {
    setEditedContent(false);
    setReportData(false);
    setPreview(!preview);
    setAreaChanged(false);
    setSubmit(true);
    setReportSearchTags(searchTags);
    scrollToTop();
    setIsBuilding(false);
    setIsMedia(false)

  };
  const updateBuildingReport = () => {
    console.log(compSettings);
    setEditedContent(false);
    setReportData(false);
    setPreview(!preview);
    setAreaChanged(false);
    setSubmit(true);
    setReportSearchTags(searchTags);
    scrollToTop();
    setIsBuilding(false);
    setIsMedia(false)
  };
  
  

  // When restoring, skip AI regeneration — we already have saved AiResponse.
  // PropertyType's .finally() sets fetchAi(true), which would trigger unnecessary AI generation.
  useEffect(() => {
    if (restoringRef.current && !fetchInProgress && fetchAi) {
      setFetchAi(false);
    }
  }, [fetchInProgress, fetchAi]);

  // When comps change with "Update Suggested Price" checked, clear stale
  // editedContent so PropertyType renders fresh computed values instead of
  // restoring old price HTML via renderEditedOrDefault / editedMap.
  useEffect(() => {
    if (reportData && reportData.updateSuggestedPrice) {
      setEditedContent(false);
      setReportData(function(prev) {
        if (!prev || !prev.updateSuggestedPrice) return prev;
        return Object.assign({}, prev, { updateSuggestedPrice: false });
      });
    }
  }, [reportData]);

  useEffect(() => {
    const fetchData = async () => {
      scrollToTop();
    };

    //fetchData();
  }, [
    formValues.details,
    ,
    formValues.branding,
    formValuesCheckboxes,
    props.user,
  ]);

  useEffect(() => {
    const loadCharts = async () => {
      if (
        formValuesCheckboxes.includes("showSnapshotBuildingCharts") &&
        formValues.details === "no-details"
      ) {
        setUnitListProgress(true);

        const resolvedHtml = await _renderChartHTML(); // Call the function that returns the promise
        setRenderChart(resolvedHtml);
        setUnitListProgress(false);
      }
    };

    loadCharts();
  }, [formValuesCheckboxes]);

  useEffect(() => {
    if (!isModalOpen) {
      //setReportLoaded(false);
    }
  }, [isModalOpen]);

  useEffect(() => {
    console.log(searchTags);
    if (isFirstRender.current) {
      // Skip the first render (initial hydration)
      isFirstRender.current = false;
      prevSearchTagsRef.current = searchTags; // Set the initial value of searchTags
      return;
    }

    const prevSearchTags = prevSearchTagsRef.current;
    if (!_isEqual(prevSearchTags, searchTags)) {
      setAreaChanged(true);
      setSubmit(true);
    }

    // Update the previous searchTags reference for next render
    prevSearchTagsRef.current = searchTags;
  }, [searchTags]);

  function calculateBoundingBox(polyHoods) {
    let minLng = Infinity,
      minLat = Infinity,
      maxLng = -Infinity,
      maxLat = -Infinity;

    polyHoods.forEach((polygon) => {
      polygon.coordinates.forEach((coord) => {
        const [lng, lat] = coord.map(Number); // Convert string to number
        if (lng < minLng) minLng = lng;
        if (lat < minLat) minLat = lat;
        if (lng > maxLng) maxLng = lng;
        if (lat > maxLat) maxLat = lat;
      });
    });

    return [
      [minLng, minLat],
      [maxLng, maxLat],
    ];
  }

  console.log(formValues, "formValuesSettingFormUpdated");
  const handleCopy = async (e) => {
    e.preventDefault();
    setProgress("Submitting...");
    
    const iframe = iframeRef.current;
    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
    
    const scriptParagraphs = iframeDoc.querySelectorAll("p.copy-script");
    const combinedText = Array.from(scriptParagraphs)
    .map(p => p.innerHTML.replace(/<br\s*\/?>/gi, '\n').trim())
    .join("\n\n");
    
    try {
      await navigator.clipboard.writeText(combinedText);
     
      setProgress("Copied to clipboard!");
      setTimeout(() => {
        setProgress(null);
      }, 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
      setProgress("Failed to copy content.");
      setTimeout(() => {
        setProgress(null);
      }, 2000);
    }
  };

  const handleExport = async (e) => {
    e.preventDefault();
    setProgress("Submitting...");
    
    const iframe = iframeRef.current;
    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
    let htmlContent = iframeDoc.documentElement.outerHTML;
    let height = reportItem && reportItem.style && reportItem.style.height
      ? reportItem.style.height : null;
    
    let width = reportItem && reportItem.style && reportItem.style.width
      ? reportItem.style.width : null;
    
    if (
      (height === "auto") ||
      (width === "auto")
    ) {
      const updateDimensions = function () {
        const exportPage = iframeDoc.querySelector('.export-page');
        if (exportPage) {
          if (height === "auto" || !height) {
            height = exportPage.scrollHeight;
          }
          if (width === "auto" || !width) {
            width = exportPage.scrollWidth;
          }
      
          // Add 100px to the calculated height
          const adjustMargin = reportItem && reportItem.bottomMargin ? reportItem.bottomMargin : 0;
          const adjustedHeight = height + adjustMargin;
          height = adjustedHeight;
          iframe.style.height = `${(height + adjustMargin)}px`;
          exportPage.style.height = `${adjustedHeight}px`;
          htmlContent = iframeDoc.documentElement.outerHTML;
          
        }
      };
    
      if (iframeDoc.fonts && iframeDoc.fonts.ready) {
        await iframeDoc.fonts.ready.then(updateDimensions);
      } else {
        // fallback if fonts.ready unsupported
        await new Promise(resolve => setTimeout(() => {
          updateDimensions();
          resolve();
        }, 300));
      }
    }

    
    const uniqueId = uuidv4();
    const ext =
      reportItem && reportItem.downloadType && reportItem.downloadType
        ? reportItem.downloadType
        : "pdf";

    // Build a friendly download name from report type + geography/building + date range
    const _sanitizeFileName = (str) => str.replace(/[^a-zA-Z0-9-]+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
    const _reportName = (reportItem && reportItem.name) || 'Report';
    let _locationPart = 'NYC';
    if (reportItem && reportItem.isBuilding && compSettings && compSettings.selectedBuilding) {
      const bldg = compSettings.selectedBuilding;
      _locationPart = bldg.display_full_street_address || bldg.full_street_address || 'NYC';
    } else if (searchTags && searchTags.length > 0) {
      _locationPart = summarizeGeographies(searchTags, true) || 'NYC';
    }
    const _isBuildingReport = reportItem && reportItem.isBuilding;
    const _dateRange = _isBuildingReport
      ? moment().format('YYYY-MM-DD')
      : (formValues && formValues.dateOptions && formValues.dateOptions.startDate && formValues.dateOptions.endDate
        ? `${moment(formValues.dateOptions.startDate).format('YYYY-MM-DD')}-to-${moment(formValues.dateOptions.endDate).format('YYYY-MM-DD')}`
        : moment().format('YYYY-MM-DD'));
    const _friendlyParts = [_sanitizeFileName(_reportName), _sanitizeFileName(_locationPart), _dateRange].filter(Boolean).join('-');
    const friendlyExportName = `${_friendlyParts}.${ext}`;

    const fileName = `${user.id}/Marketproof-Download-${uniqueId}.${ext}`;
    const exportName = friendlyExportName;
    setExportInProgress(true);

    try {
      let response;
      if (
        reportItem &&
        reportItem.downloadType &&
        reportItem.downloadType == "png"
      ) {
        response = await fetch(`${exportAPIURL}/generate-image-save`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            jobId: jobIdRef.current,
            html: htmlContent,
            format: "png",
            width: width,
            height: height,
          }),
        });
      } else if (
        reportItem &&
        reportItem.downloadType &&
        reportItem.downloadType == "zip"
      ) {
        response = await fetch(`${exportAPIURL}/generate-images-zip`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            jobId: jobIdRef.current,
            html: htmlContent,
            format: "png",
            width: width,
            height: height,
          }),
        });
      } else {
        response = await fetch(`${exportAPIURL}/generate-pdf-save`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            jobId: jobIdRef.current,
            html: htmlContent,
            orientation: "portrait",
            fileName,
          }),
        });
      }

      // Store the export name so SSE handler can use it for download
      downloadFileNameRef.current = exportName;

      if (!response.ok) {
        console.error("Failed to submit PDF job");
        setProgress("Error generating PDF");
        setExportInProgress(false);
      }
      // Download is triggered by SSE when the server sends the final URL
    } catch (error) {
      console.error("Error exporting PDF:", error);
      setProgress("Error generating PDF");
      setExportInProgress(false);
    }
  };

  const handleMapLoad = (loaded) => {
    setIsMapLoaded(loaded);
  };

  const getZoom = () => {
    const sliderValue = zoom;

    // Map the slider value (from any range, e.g., 10-200) to a zoom factor
    // Assuming slider range from 10 to 200
    const zoomValue = sliderValue / 100;

    // Round to the nearest 0.04 increment
    const roundedZoom = Math.round((zoomValue - 1) / 0.07) * 0.07 + 1;
    return roundedZoom;
  };

  const ext =
    reportItem && reportItem.downloadType && reportItem.downloadType
      ? reportItem.downloadType
      : "pdf";

  const sliderOpen = isSliderOpen();
  
  const snackClose = (event, reason) => {
      if (reason === 'clickaway') {
        return;
      }	
      setSnackShow(false);
      setSnackMessage(false);
  };
  const snackOpen = (message, type) => {
    setSnackShow(true);
    setSnackMessage(message);
    setSnackType(type);
  };
  
  const openDetailModal = (key) => {
    setShareKey(key);
    setShareModal(true);
  };
  
  const closeDetailModal = () => {
    setShareModal(false);
    setShareKey(null);
  };
  console.log(compSettings);

  const buttonDisabled = fetchInProgress || aiInProgress || fetchAi;
  return (
    <div>
      <SnackBar
        snackShow={snackShow}
        snackMessage={snackMessage}
        snackClose={snackClose}
        snackDuration={5000}
        snackType={snackType}
      />
      <Modal
        isOpen={pageToDeleteIndex !== null}
        toggle={() => setPageToDeleteIndex(null)}
        modalClassName={`ltr-support ${_getReportModalThemeClass()}`}
        className="modal-dialog--primary modal-dialog--header report-action-modal"
        zIndex={2000}
      >
        <div className="modal__header">
          <button
            className="lnr lnr-cross modal__close-btn"
            type="button"
            onClick={() => setPageToDeleteIndex(null)}
          />
          <h4 className="text-modal modal__title">
            <TrashCanIcon size={22} color="#EDDEF5" style={{ marginRight: 8, verticalAlign: "middle" }} />
            Delete Page
          </h4>
        </div>
        <div className="modal__body">
          <p>Are you sure you want to delete this page?</p>
        </div>
        <ButtonToolbar className="modal__footer">
          <Tooltip title="Cancel">
            <Button
              onClick={() => setPageToDeleteIndex(null)}
              variant="outlined"
              style={{ marginRight: 10 }}
            >
              Cancel
            </Button>
          </Tooltip>
          <Tooltip title="Delete this page">
            <Button
              onClick={() => {
                const iframe = iframeRef.current;
                const iframeDoc = iframe && (iframe.contentDocument || iframe.contentWindow.document);
                if (iframeDoc) {
                  const pages = iframeDoc.querySelectorAll(".export-page");
                  const target = pages[pageToDeleteIndex];
                  if (target && target.parentNode) {
                    target.parentNode.removeChild(target);
                    handleSaveChanges(iframeDoc.getElementById("root").innerHTML);
                  }
                }
                setPageToDeleteIndex(null);
              }}
              variant="contained"
              color="secondary"
              className="buyersList__primary-button"
            >
              Delete
            </Button>
          </Tooltip>
        </ButtonToolbar>
      </Modal>
      <Modal
        isOpen={showExitConfirm}
        toggle={() => setShowExitConfirm(false)}
        modalClassName={`ltr-support ${_getReportModalThemeClass()}`}
        className="modal-dialog--primary modal-dialog--header report-action-modal"
        zIndex={2000}
      >
        <div className="modal__header">
          <button
            className="lnr lnr-cross modal__close-btn"
            type="button"
            onClick={() => setShowExitConfirm(false)}
          />
          <h4 className="text-modal modal__title">
            <ExitToAppIcon size={22} color="#EDDEF5" style={{ marginRight: 8, verticalAlign: "middle" }} />
            Exit Report
          </h4>
        </div>
        <div className="modal__body">
          <p>Are you sure you want to exit?</p>
        </div>
        <ButtonToolbar className="modal__footer">
          <Tooltip title="Cancel">
            <Button
              onClick={() => setShowExitConfirm(false)}
              variant="outlined"
              style={{ marginRight: 10 }}
            >
              Cancel
            </Button>
          </Tooltip>
          <Tooltip title="Exit report">
            <Button
              onClick={() => {
                setShowExitConfirm(false);
                performExitReport();
              }}
              variant="contained"
              color="primary"
              className="buyersList__primary-button"
            >
              Exit
            </Button>
          </Tooltip>
        </ButtonToolbar>
      </Modal>
      <NestedModal
        isOpen={isNestedModalOpen}
        toggle={() => setIsNestedModalOpen(false)}
        ref={iframeRef}
        headerContent={headerContent}
        scripts={scripts}
        headerHTML={
          isHeaderAvailable ? <ReportHeader /> : null
        }
        footerHTML={
          isFooterAvailable ? <ReportFooter /> : null
        }
        contentHTML={
          editedContent ? editedContent : ReportContent
        }
        preview={preview}
        searchTags={searchTags}
        boundingBoxCoord={boundingBoxCoord}
        setIsMapLoaded={setIsMapLoaded}
        isMapLoaded={isMapLoaded}
        handleMapLoad={handleMapLoad}
        formValues={formValues}
        formValuesCheckboxes={formValuesCheckboxes}
        isEditMode={isEditMode}
        onSaveChanges={handleSaveChanges}
        layoutStyle={layoutStyle}
        setFetchAi={setFetchAi}
        setAiResponse={setAiResponse}
        fetchAi={fetchAi}
        AiResponse={AiResponse}
        setAIInProgress={setAIInProgress}
        setIsNestedModalOpen={setIsNestedModalOpen}
        setReportData={setReportData}
        reportData={reportData}
        nestedModalData={nestedModalData}
        setNestedModalData={setNestedModalData}
        setSubmit={setSubmit}
        openDetailModal={openDetailModal}
        disabled={buttonDisabled}
        clearTags={clearTags}
        addTag={addTag}
      />
      <DetailModal
        shareModal={shareModal}
        shareKey={shareKey}
        toggleModal={closeDetailModal}
        
      />
      <Modal
        isOpen={isModalOpen}
        toggle={handleModalToggle}
        size="lg"
        className={`modal-dialog pdf_export_modal ${user && user.role && Array.isArray(user.role) ? user.role.join(" ") : ""}`}
        ref={previewContainerRef}
        trapFocus={!isNestedModalOpen}
      >
        <div style={{}}>
          <CssBaseline />
          <AppBar
            position="fixed"
            style={{ zIndex: 1201 }}
            className={`mcAppBar ${classes.appBar}`}
          >
            <Toolbar className={classes.appToolBar}>
              <Typography
                variant="h6"
                noWrap
                className={classes.title}
                style={{ width: 200, justifyContent: "left" }}
              >
                Preview & Customize
              </Typography>
            {!isBuilding ?   
              
              ( <Toolbar className={classes.toolBar}>
                {reportItem && reportItem.reportComponent === "NewsletterCustom" ? null : <Tooltip title="Upload your logo and change your contact method">
                  <Button
                    startIcon={<LogoIcon />}
                    className={`${classes.button} ${
                      showBrandingSlider ? "activeButton" : ""
                    }`} // Apply active class conditionally
                    onClick={handleToggleBrandingSlider}
                    disabled={fetchInProgress || fetchAi}
                  >
                    {user && user.logo ? "Brand" : "Brand"}
                    {showBrandingSlider ? (
                      <ChevronUpIcon size={18} />
                    ) : (
                      <ChevronDownIcon size={18} />
                    )}
                  </Button>
                </Tooltip>}

                {reportItem && reportItem.reportComponent === "NewsletterCustom" ? null : <Tooltip title="Select a theme to customize look and feel of your report">
                  <Button
                    startIcon={<ThemeIcon />}
                    className={`${classes.button} ${
                      showThemeSlider ? "activeButton" : ""
                    }`} // Apply active class conditionally
                    onClick={handleToggleThemeSlider}
                    disabled={fetchInProgress ||fetchAi}
                  >
                    Theme
                    {showThemeSlider ? (
                      <ChevronUpIcon size={18} />
                    ) : (
                      <ChevronDownIcon size={18} />
                    )}
                  </Button>
                </Tooltip>}
                {reportItem && reportItem.isBuilding ? <></> : <Tooltip title="Change the borough, neighborhood or area of this report">
                  <Button
                    startIcon={<MapIcon />}
                    className={`${classes.button} ${
                      showSearchBar ? "activeButton" : ""
                    }`} // Apply active class conditionally
                    onClick={handleToggleSearchBar}
                    disabled={fetchInProgress || fetchAi || aiInProgress}
                  >
                    {reportItem && reportItem.isBuilding ? "Building" : "Area"}{" "}
                    {searchTags && searchTags.length > 0 ? (
                      <span className="small-text" style={{ marginLeft: 5 }}>
                        ({searchTags.length})
                      </span>
                    ) : null}{" "}
                    {showSearchBar ? (
                      <ChevronUpIcon size={18} />
                    ) : (
                      <ChevronDownIcon size={18} />
                    )}
                  </Button>
                </Tooltip>}
                {reportItem && reportItem.hideDate  ? null :
                <Tooltip title="Choose time period for this report">
                  <Button
                    startIcon={<TimeIcon />}
                    className={`${classes.button} ${
                      showDateComp ? "activeButton" : ""
                    }`} // Apply active class conditionally
                    onClick={handleToggleDateBar}
                    disabled={fetchInProgress || fetchAi || aiInProgress}
                  >
                    Date{" "}
                    {showDateComp ? (
                      <ChevronUpIcon size={18} />
                    ) : (
                      <ChevronDownIcon size={18} />
                    )}
                  </Button>
                </Tooltip>}

                <Tooltip
                  title={
                    isEditMode
                      ? "Preview report - exit edit mode and remove dotted lines"
                      : "Edit report - editable content marked by dotted lines"
                  }
                >
                  <Button
                    startIcon={isEditMode ? <PreviewIcon /> : <EditIcon />}
                    className={`${classes.button} ${
                      isEditMode ? "activeButton" : ""
                    }`} // Apply active class conditionally
                    onClick={() => setIsEditMode(!isEditMode)}
                    activated={isEditMode}
                    disabled={fetchInProgress || aiInProgress  || fetchAi}

                  >
                    {isEditMode ? "Preview" : "Edit"}
                  </Button>
                </Tooltip>
              </Toolbar> ):null}
              <div style={{ width: 200, textAlign: "right" }}>
                {/* <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  edge="end"
                  onClick={toggleDrawer}
                >
                  <ChevronLeftIcon color={"white"} />
                </IconButton> */}
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  edge="end"
                  onClick={() => {
                    if (sliderOpen) {
                      closeAllSliders();
                      return;
                    }
                    setShowExitConfirm(true);
                  }}
                  style={{ marginLeft: 5 }}
                >
                  {sliderOpen ? (
                    <ChevronUpIcon size={18} color={"white"} />
                  ) : (
                    <CloseIcon size={20} color={"white"} />
                  )}
                </IconButton>
              </div>
            </Toolbar>
          </AppBar>
          <Slide direction="down" in={showSearchBar} mountOnEnter unmountOnExit>
            <div
              id="geo-search-bar"
              className={`appBarSlider ${searchClasses.searchBarContainer}`}
              ref={searchBarRef}
            >
              <div
                style={{
                  maxWidth: 900,
                  margin: "0 auto",
                  display: "flex",
                  gap: 0,
                  alignItems: "center",
                }}
              >
              {reportItem && reportItem.isBuilding ? 
                <GeneralBuildingSearchBar
                  buildingFilter={
                    '(ownership_type:"condo" OR ownership_type:"condo-retail" OR building_status:"sponsor" OR ownership_type:"coop" OR ownership_type:"rental")'
                  }
                  handleSearch={updateBuildingReport}
                  buildingAttributes={[]}
                  placeHolder={
                    "Address or Building Name"
                  }
                  addBuilding={false}
                  buildingTab={null}
                  hideBoroHood={true}
                  hideAddIcon={true}
                  hideMapDraw={true}
                   searchBarStyles={searchBarStyles}
                   exitMessageData={{title:"Report Unavailable", message:"Building reports are currently only available for condos and co-ops.  Click continue if you would like to learn more about this property on our public website."}}
                />:
                <>
                  {/* hideBuilding drops the building index from the autocomplete entirely.
                      hideAddIcon only removed the affordance, so buildings still came back as you
                      typed and could be selected into a tag the report cannot use. */}
                  <GeneralBuildingSearchBar
                    buildingFilter={
                      '(ownership_type:"condo" OR ownership_type:"condo-retail" OR building_status:"sponsor" OR ownership_type:"coop" OR ownership_type:"rental")'
                    }
                    handleSearch={null}
                    buildingAttributes={[]}
                    placeHolder={
                      reportSearchTypes && reportSearchTypes.indexOf("area") < 0
                        ? "Search for a Borough or Neighborhood"
                        : "Search for Borough, Neighborhood, or Use the Map"
                    }
                    addBuilding={!reportSearchTypes || reportSearchTypes.indexOf("building") >= 0}
                    buildingTab={null}
                    hideBoroHood={false}
                    hideBuilding={!!reportSearchTypes && reportSearchTypes.indexOf("building") < 0}
                    hideAddIcon={!!reportSearchTypes && reportSearchTypes.indexOf("building") < 0}
                    hideMapDraw={!!reportSearchTypes && reportSearchTypes.indexOf("area") < 0}
                    searchBarStyles={searchBarStyles}
                  />
                  <Tooltip title={"Rewrite report with the updated area"}>
                    <Button
                      startIcon={<RefreshIcon />}
                      className={searchClasses.searchButton}
                      onClick={updateReport}
                      disabled={!areaChanged || fetchAi}
                    >
                      Update
                    </Button>
                  </Tooltip>
                </>
              }
                
              </div>
            </div>
          </Slide>
          <Slide direction="down" in={showDateComp} mountOnEnter unmountOnExit>
            <div
              id="date-bar"
              className={`appBarSlider ${searchClasses.searchBarContainer}`}
              ref={dateBarRef}
            >
              <div
                style={{
                  margin: "0 auto",
                  display: "flex",
                  gap: 0,
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <CustomDateComp
                  formValues={formValues}
                  setFormValues={setFormValues}
                  setPreview={setPreview}
                  fetchInProgress={fetchInProgress }
                  setParentFetchInProgress={setFetchInProgress}
                  setReportData={setReportData}
                  submit={submit}
                  setSubmit={setSubmit}
                  slideClass={true}
                  allowedIntervals={reportDateIntervals}
                />
              </div>
            </div>
          </Slide>
          <Slide
            direction="down"
            in={showBrandingSlider}
            mountOnEnter
            unmountOnExit
          >
            <div
              id="branding-slider"
              className={`appBarSlider ${searchClasses.searchBarContainer}`}
              ref={brandingSliderRef}
            >
              <ExportSettingsForm
                user={user}
                setPreview={() => setPreview(!preview)}
                setParentFetchInProgress={setFetchInProgress}
                formValues={formValues}
                setFormValues={setFormValues}
                {...props}
                defaultValues={defaultValues}
                aiInProgress={aiInProgress}
                setFormValuesCheckboxes={setFormValuesCheckboxes}
                formValuesCheckboxes={formValuesCheckboxes}
                panel={"branding"}
                setReportData={setReportData}
                setSubmit={setSubmit}
                submit={submit}
                isDrawerOpen={isDrawerOpen}
                color={color}
                setColor={setColor}
                selectedFont={selectedFont}
                setSelectedFont={setSelectedFont}
                defaultLogo={defaultLogo}

              />
            </div>
          </Slide>

          <Slide
            direction="down"
            in={showThemeSlider}
            mountOnEnter
            unmountOnExit
          >
            <div
              id="theme-slider"
              className={`appBarSlider ${searchClasses.searchBarContainer}`}
              ref={themeSliderRef}
            >
              <ExportSettingsForm
                user={user}
                setPreview={() => setPreview(!preview)}
                setParentFetchInProgress={setFetchInProgress}
                formValues={formValues}
                setFormValues={setFormValues}
                {...props}
                defaultValues={defaultValues}
                aiInProgress={aiInProgress}
                setFormValuesCheckboxes={setFormValuesCheckboxes}
                formValuesCheckboxes={formValuesCheckboxes}
                panel={"theme"}
                setReportData={setReportData}
                setSubmit={setSubmit}
                submit={submit}
                isDrawerOpen={isDrawerOpen}
                color={color}
                setColor={setColor}
                selectedFont={selectedFont}
                setSelectedFont={setSelectedFont}
                backgroundColor={backgroundColor}
                setBackgroundColor={setBackgroundColor}
                textColor={textColor}
                setTextColor={setTextColor}

              />
            </div>
          </Slide>

          {!isBuilding ? (
         <>
            <main
              className={classes.content}
              style={{
                flexGrow: 1,
                padding: "16px",
                marginLeft: 0,
                marginTop: sliderHeight,
              }}
            >
              <div className="pdf_modal_container">
                <div className="pdf_preview">
                  <div
                    className="modal__body"
                    style={{
                      height: "100%",
                      minHeight: "calc(100vh - 250px)",
                      padding: 15,
                    }}
                  >
                    <div style={{ padding: "0 20px" }}>
                      <ZoomSlider
                        zoom={zoom}
                        setZoom={setZoom}
                        disabled={!((!fetchInProgress && reportData) || restoringRef.current)}
                      />
                    </div>

                    <div
                      style={{
                        marginTop: "3em",
                      }}
                    >
                      <div
                        id={"previewContainer"}
                        style={{
                          width:
                            layoutStyle && layoutStyle.width
                              ? `${new Number(layoutStyle.width) + 40}px`
                              : "100%",
                          margin: "auto",
                          transform: `scale(${((!fetchInProgress && reportData) || restoringRef.current) ? getZoom() : '100%'})`,
                          filter: "blur(0px)",
                          backfaceVisibility: "hidden",
                          transformOrigin: "top center",
                        }}
                      >
                        {((!fetchInProgress && reportData) || restoringRef.current)  ? (
                          <div>
                            <ExportView
                              ref={iframeRef}
                              headerContent={headerContent}
                              scripts={scripts}
                              headerHTML={
                                isHeaderAvailable ? <ReportHeader /> : null
                              }
                              footerHTML={
                                isFooterAvailable ? <ReportFooter /> : null
                              }
                              contentHTML={
                                (reportItem && reportItem.trackEdit && restoringRef.current && editedContent) ? editedContent
                                : (reportItem && reportItem.trackEdit) ? ReportContent
                                : !editedContent ? ReportContent
                                : editedContent
                              }
                              preview={preview}
                              searchTags={searchTags}
                              boundingBoxCoord={boundingBoxCoord}
                              setIsMapLoaded={setIsMapLoaded}
                              isMapLoaded={isMapLoaded}
                              handleMapLoad={handleMapLoad}
                              formValues={formValues}
                              formValuesCheckboxes={formValuesCheckboxes}
                              isEditMode={isEditMode}
                              onSaveChanges={handleSaveChanges}
                              layoutStyle={layoutStyle}
                              setFetchAi={setFetchAi}
                              setAiResponse={setAiResponse}
                              fetchAi={fetchAi}
                              AiResponse={AiResponse}
                              setAIInProgress={setAIInProgress}
                              setNestedModal={setNestedModal}
                              openDetailModal={openDetailModal}
                              user={user}
                              reportData={reportData}
                              onRequestPageDelete={setPageToDeleteIndex}
                            />
                            
                          </div>
                        ) : (
                          <ReportLoading />
                        )}
                      </div>
                    </div>
                    {/* </div> */}
                    {!reportData && ReportContent}
     
                  </div>
                </div>
              </div>
            </main>
               <div>
               <Fragment>
                 {progress ? (
                   <div
                     id="progress"
                     className="export-progress"
                     style={{
                       padding: 20,
                       background: "#FFF",
                       position: "fixed",
                       top: "50%",
                       left: "50%",
                       transform: "translate(-50%, -50%)",
                       width: "60%",
                       height: 75,
                       border: "2px solid #171F26",
                     }}
                   >
                     <Typography
                       variant="h5"
                       noWrap
                       className={classes.drawerHeaderTitle}
                       style={{ textAlign: "center" }}
                     >
                       <FileExportIcon
                         size={32}
                         color="#780F9E"
                         style={{ marginTop: -5 }}
                       />{" "}
                       {progress}...
                     </Typography>
                   </div>
                 ) : null}
                 <div
                   style={{
                     position: "fixed",
                     bottom: 50,
                     right: 50,
                     zIndex: 9999,
                   }}
                 >
                 
                 {/*reportItem && reportItem.isBuilding && (reportItem.isBuilding == "comp") ?
                   <CompSourceSelector setNestedModal={setNestedModal} />

                 :
                   null
                 */}
                 
                 {reportItem && reportItem.reportType && reportItem.reportType == "video-script" ?
                 <>
                    <HeyGenExportButton 
                      iframeRef={iframeRef}
                      {...props} 
                      setAIInProgress={setAIInProgress} 
                      toggleModal={toggleModal}
                      className={classes.fab} 
                      snackOpen={snackOpen}
                      disabled={buttonDisabled} />
            
                     </>: null}
                     
                  {reportItem && reportItem.reportType && reportItem.reportType == "listing-desc" ?
                   <>
                   {!buttonDisabled ?
                      <Fab
                        variant="extended"
                        size="medium"
                        color="secondary"
                        aria-label="add"
                        className={classes.fab}
                        onClick={()=>{setAiResponse(null);setIsBuilding("listing-desc")}}
                        disabled={buttonDisabled}
                        style={{marginRight:10}}
                      >
                        <CopyIcon style={{ marginRight: 5 }} /> {` `}
                        Regenerate
                      </Fab>:null}
                      {!buttonDisabled ?
                      <Fab
                         variant="extended"
                         size="medium"
                         color="secondary"
                         aria-label="add"
                         className={classes.fab}
                         onClick={handleCopy}
                         disabled={buttonDisabled}
                         style={{marginRight:10}}
                       >
                         <CopyIcon style={{ marginRight: 5 }} /> {` `}
                         Copy Description
                       </Fab>:null}
                       
                  
                       </>: null}
                   <Tooltip
                     title={
                       ext == "png"
                         ? "Export Image as PNG"
                         : `Export Report as PDF`
                     }
                   >
                
                     <Fab
                       variant="extended"
                       size="medium"
                       color="secondary"
                       aria-label="add"
                       className={classes.fab}
                       onClick={handleExport}
                       disabled={buttonDisabled}
                     >
                       <FileExportIcon style={{ marginRight: 5 }} /> {` `}
                       {fetchInProgress ? "Generating..." : 
                       (aiInProgress || fetchAi) ? "Summarizing..." : 
                        exportInProgress && isMapLoaded
                         ? "Downloading... "
                         : ext == "png"
                         ? "Download Image"
                         : ext == "zip"
                         ? "Download Images (Zip)"
                         : reportItem && reportItem.reportType && reportItem.reportType == "video-script"
                         ? "Download Script"
                         : reportItem && reportItem.reportType && reportItem.reportType == "listing-desc"
                          ? "Download as PDF"
                         :  "Download Report"}
                     </Fab>
                   </Tooltip>
                   <Tooltip title={`Close`}>
                     <Fab
                       variant="extended"
                       size="medium"
                       color="secondary"
                       aria-label="add"
                       className={classes.fabClose}
                       onClick={() => {
                        if (sliderOpen) {
                          closeAllSliders();
                        } else {
                          // Save comp report draft before closing
                          if (isCompReportType && compSettings && compSettings.selectedBuilding) {
                            saveCompDraftForCurrent({
                              editedContent,
                              AiResponse,
                              compSettings,
                              searchTags,
                              reportData,
                              formValuesPartial: {
                                reportTitle: formValues.reportTitle,
                                summary: formValues.summary,
                                details: formValues.details,
                              },
                            });
                          }
                          toggleModal();
                          setFormValues({
                            ...formValues,
                            dateOptions: {
                              startDate: defaultDate(isBuildingReport).startDate,
                              endDate: defaultDate(isBuildingReport).endDate,
                              previousStartDate: defaultPreviousPeriod(isBuildingReport).startDate,
                              previousEndDate: defaultPreviousPeriod(isBuildingReport).endDate,
                              gap: isBuildingReport ? "+3MONTH" : "+1MONTH",
                              isCustomPreviousSelected: false,
                              isPreviousSelectedClicked: false,
                              anyChangeOccured: false,
                            },
                          });
                          setIsBuilding && setIsBuilding(false);
                          setIsMedia && setIsMedia(false)
                          setReportData(null);
                          setAiResponse(null);
                          setFetchAi(false)
                          setFetchInProgress(false);
                          setReportLoaded(false)
                          console.log("modalClose");
                        }
                      }}
                       disabled={buttonDisabled}
                     >
                       Close
                     </Fab>
                   </Tooltip>
                 </div>
               </Fragment>
             </div>
         </>
          ) : isBuilding && isBuilding =="comp" ?
          <CompPropertySelector updateBuildingReport={updateBuildingReport} {...props} setCompSettings={setCompSettings} compSettings={compSettings} onRestoreDraft={handleRestoreCompDraft} />
          : isBuilding && isBuilding =="comp-rental" ?
          <RentalCompPropertySelector updateBuildingReport={updateBuildingReport} {...props} setCompSettings={setCompSettings} compSettings={compSettings} onRestoreDraft={handleRestoreCompDraft} />
          : isBuilding && isBuilding =="coming-soon" ?
          <PropertySelector updateBuildingReport={updateBuildingReport} {...props} setCompSettings={setCompSettings} compSettings={compSettings} />
          : isBuilding && isBuilding =="listing-desc" ?
          <ListingDescSelector setIsBuilding={setIsBuilding} updateBuildingReport={updateBuildingReport} {...props} setCompSettings={setCompSettings} compSettings={compSettings} />
          :
          <BuildingSearchSelector updateBuildingReport={updateBuildingReport} {...props}  />
      }
        </div>

       
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
    searchTags: Array.isArray(state.search.searchTags)
      ? state.search.searchTags.slice().map((tag) => {
          if (
            tag.type === "neighborhood" &&
            !tag.data.hood.includes("manhattan")
          ) {
            return {
              ...tag,
              id: `${tag.data.hood.toLowerCase().replace(/\s+/g, "-")}_${
                tag.data.boro
              }`,
            };
          } else if (
            tag.type === "neighborhood" &&
            tag.data.hood.includes("manhattan")
          ) {
            return {
              ...tag,
              id: `${tag.data.hood
                .replace("manhattan", "")
                .trim()
                .toLowerCase()
                .replace(/\s+/g, "-")}_${tag.data.boro}`,
            };
          } else return tag;
        })
      : [],
  };
};

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators(searchActions, dispatch) };
}

export default connect(mapStateToProps, mapDispatchToProps)(ExportModal);
